import { Component, inject, Inject, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, CustomerDetailsComponent, CustomerService, NavbarConfigService, NavigationConfig, FeatureActivatedGuardWrapper, CustomerDetailsConfigService } from 'gung-standard';
import { JeevesCustomerActionConfigService } from '../../services/jeeves-customer-action-config/jeeves-customer-action-config.service';

@Component({
    selector: 'gung-jeeves-jeeves-customer-details-wrapper',
    templateUrl: './jeeves-customer-details-wrapper.component.html',
    styleUrls: ['./jeeves-customer-details-wrapper.component.css'],
    standalone: false
})
export class JeevesCustomerDetailsWrapperComponent extends CustomerDetailsComponent implements OnInit {

  public configService = inject(JeevesCustomerActionConfigService);


  ngOnInit() {
    super.ngOnInit();
  }
}
